class SalePopup extends HTMLElement {
  constructor() {
    super();
    this.hasTriggered = false;
    this.handleScroll = this.handleScroll.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this.handleScroll);
    this.addEventListener('click', this.handleClick);
    
    const closeBtn = this.querySelector('[data-popup-close]');
    if (closeBtn) closeBtn.onclick = () => this.close();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (!this.hasTriggered && window.scrollY >= window.innerHeight * 0.6) {
      this.open();
      this.hasTriggered = true;
    }
  }

  handleClick(e) {
    if (e.target === this) this.close();
  }

  open() {
    this.classList.add('active');
    // document.body.style.overflow = 'hidden';
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove('active');
    // document.body.style.overflow = 'auto';
    document.body.classList.remove("overflow-hidden")
  }

  reset() {
    this.hasTriggered = false;
    this.close();
  }
}

customElements.define('sale-popup', SalePopup);